import ImageRemoveEvent from './ImageRemoveEvent';

class MyUploadAdapter {
    constructor( loader ) {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }

    // Starts the upload process.
    upload() {
        return this.loader.file
            .then( file => new Promise( ( resolve, reject ) => {
                // this._initRequest();
                // this._initListeners( resolve, reject, file );
                // this._sendRequest( file );

                let uploadedFile = file;

                const data = new FormData()
                data.append("upload", uploadedFile)

                axios.post('/api/admin/stock-updates/upload/image', data, {
                        headers: {
                            'Content-Type': "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2),
                            'Accept': 'application/json'
                        }
                    })
                    .then((res)=>{
                        if ( res.data.result == "success" ) {
                            resolve( {
                                default: res.data.data
                            } );
                        } else {
                            reject(res.data.data);
                        }
                        
                    })
                    .catch((error)=>{
                        console.log(error);
                    });

            } ) );
    }

    // Aborts the upload process.
    abort() {
        // if ( axios ) {
        //     axios.abort();
        // }
        reject();
    }

}


function MyCustomUploadAdapterPlugin( editor ) {
    editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
        // Configure the URL to the upload script in your back-end here!
        return new MyUploadAdapter( loader );
        // return new myuploader( loader );
    };
}


function CustomImageRemovalPlugin(editor){

    const configuration = editor.config.get('imageRemoveEvent');
    // const documentationURL = 'https://github.com/shibbirweb/ckeditor-5-image-remove-event-plugin'

    // Validate has configuration
    if (!configuration) {
        console.warn('CKEditor5 Image Remove Event Plugin : configuration is not defined.')
        // console.warn(`View configuration documentation: ${documentationURL}`)
        return;
    }

    // validate configuration type
    if (typeof configuration !== 'object') {
        // console.info(`CKEditor5 Image Remove Event Plugin: Configuration should be an object. See documentation at: ${documentationURL}`)
        console.warn('CKEditor5 Image Remove Event Plugin: Configuration is not valid.')
    }

    const {callback, additionalElementTypes} = configuration

    // validate event callback
    if (!callback || {}.toString.call(callback) !== '[object Function]') {
        // console.info(`CKEditor5 Image Remove Event Plugin: Configuration callback property should be a function. See documentation at: ${documentationURL}`)
        console.error('CKEditor5 Image Remove Event Plugin: Callback property is not valid function.')
    }

    // validate additional image element names
    if(additionalElementTypes && !Array.isArray(additionalElementTypes)){
        console.info(`CKEditor5 Image Remove Event Plugin: Configuration 'additionalElementTypes' property should be nullable or an array. See documentation at: ${documentationURL}`)
        console.error(`CKEditor5 Image Remove Event Plugin: 'additionalElementTypes' property is not valid function.`)
    }

    return new ImageRemoveEvent(editor,configuration);
}

const CKEditorInit = (element)=>{
    let extra_toolbar_item = "";
    if(element=='ckeditor_stock_update')
    {
        extra_toolbar_item = "uploadImage";
    }
	CKEDITOR.ClassicEditor.create(document.getElementById(element), {

		toolbar: {
                items: [
                    //'exportPDF','exportWord', '|',
                    'findAndReplace', 'selectAll', '|',
                    'heading', '|',
                    'bold', 'italic', 'strikethrough', 'underline', 'code', 'subscript', 'superscript', 'removeFormat', '|',
                    'bulletedList', 'numberedList', 'todoList', '|',
                    'outdent', 'indent', '|',
                    'undo', 'redo',
                    // '-',
                    'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', 'highlight', '|',
                    'alignment', '|',
                    'link',
                    extra_toolbar_item,
                    'blockQuote', 'insertTable', '|',
                    // , 'mediaEmbed', 'codeBlock', 'htmlEmbed', '|',
                    // 'specialCharacters', 'horizontalLine', 'pageBreak', '|',
                    // 'textPartLanguage', '|',
                    'sourceEditing'
                ],
                shouldNotGroupWhenFull: true
            },
            // Changing the language of the interface requires loading the language file using the <script> tag.
            // language: 'es',
            list: {
                properties: {
                    styles: true,
                    startIndex: true,
                    reversed: true
                }
            },
            // https://ckeditor.com/docs/ckeditor5/latest/features/headings.html#configuration
            heading: {
                options: [
                    { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                    { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                    { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                    { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                    { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                    { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                    { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                ]
            },
            // https://ckeditor.com/docs/ckeditor5/latest/features/editor-placeholder.html#using-the-editor-configuration
            placeholder: 'Welcome to CKEditor 5!',
            // https://ckeditor.com/docs/ckeditor5/latest/features/font.html#configuring-the-font-family-feature
            fontFamily: {
                options: [
                    'default',
                    'Arial, Helvetica, sans-serif',
                    'Courier New, Courier, monospace',
                    'Georgia, serif',
                    'Lucida Sans Unicode, Lucida Grande, sans-serif',
                    'Tahoma, Geneva, sans-serif',
                    'Times New Roman, Times, serif',
                    'Trebuchet MS, Helvetica, sans-serif',
                    'Verdana, Geneva, sans-serif'
                ],
                supportAllValues: true
            },
            // https://ckeditor.com/docs/ckeditor5/latest/features/font.html#configuring-the-font-size-feature
            fontSize: {
                options: [ 10, 12, 14, 'default', 18, 20, 22 ],
                supportAllValues: true
            },
            // Be careful with the setting below. It instructs CKEditor to accept ALL HTML markup.
            // https://ckeditor.com/docs/ckeditor5/latest/features/general-html-support.html#enabling-all-html-features
            htmlSupport: {
                allow: [
                    {
                        name: /.*/,
                        attributes: true,
                        classes: true,
                        styles: true
                    }
                ]
            },
            // Be careful with enabling previews
            // https://ckeditor.com/docs/ckeditor5/latest/features/html-embed.html#content-previews
            // htmlEmbed: {
            //     showPreviews: true
            // },
            // https://ckeditor.com/docs/ckeditor5/latest/features/link.html#custom-link-attributes-decorators
            // link: {
            //     decorators: {
            //         addTargetToExternalLinks: true,
            //         defaultProtocol: 'https://',
            //         toggleDownloadable: {
            //             mode: 'manual',
            //             label: 'Downloadable',
            //             attributes: {
            //                 download: 'file'
            //             }
            //         }
            //     }
            // },
            // https://ckeditor.com/docs/ckeditor5/latest/features/mentions.html#configuration
            // mention: {
            //     feeds: [
            //         {
            //             marker: '@',
            //             feed: [
            //                 '@apple', '@bears', '@brownie', '@cake', '@cake', '@candy', '@canes', '@chocolate', '@cookie', '@cotton', '@cream',
            //                 '@cupcake', '@danish', '@donut', '@dragée', '@fruitcake', '@gingerbread', '@gummi', '@ice', '@jelly-o',
            //                 '@liquorice', '@macaroon', '@marzipan', '@oat', '@pie', '@plum', '@pudding', '@sesame', '@snaps', '@soufflé',
            //                 '@sugar', '@sweet', '@topping', '@wafer'
            //             ],
            //             minimumCharacters: 1
            //         }
            //     ]
            // },
            // The "superbuild" contains more premium features that require additional configuration, disable them below.
            // Do not turn them on unless you read the documentation and know how to configure them and setup the editor.
            removePlugins: [
                // These two are commercial, but you can try them out without registering to a trial.
                // 'ExportPdf',
                // 'ExportWord',
                'AIAssistant',
                'CKBox',
                'CKFinder',
                'EasyImage',
                // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
                // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
                // Storing images as Base64 is usually a very bad idea.
                // Replace it on production website with other solutions:
                // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
                'Base64UploadAdapter',
                'RealTimeCollaborativeComments',
                'RealTimeCollaborativeTrackChanges',
                'RealTimeCollaborativeRevisionHistory',
                'PresenceList',
                'Comments',
                'TrackChanges',
                'TrackChangesData',
                'RevisionHistory',
                'Pagination',
                'WProofreader',
                // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
                // from a local file system (file://) - load this site via HTTP server if you enable MathType.
                'MathType',
                // The following features are part of the Productivity Pack and require additional license.
                'SlashCommand',
                'Template',
                'DocumentOutline',
                'FormatPainter',
                'TableOfContents',
                'PasteFromOfficeEnhanced',
                'CaseChange'
            ],
            extraPlugins : [MyCustomUploadAdapterPlugin,CustomImageRemovalPlugin],
            imageRemoveEvent: {
                additionalElementTypes: ['image', 'imageBlock', 'inlineImage'], // Demo to write additional element types
                // additionalElementTypes: null, // Add additional element types to invoke callback events. Default is null. Already included ['image','imageBlock','inlineImage']
                callback: (imagesSrc, nodeObjects) => {
                    // note: imagesSrc is array of src & nodeObjects is array of nodeObject
                    // node object api: https://ckeditor.com/docs/ckeditor5/latest/api/module_engine_model_node-Node.html
                    axios.post('/api/admin/stock-updates/uploaded/image', {image_url:imagesSrc[0]}, {
                        headers: {
                            'Content-Type': "application/json",
                            'Accept': 'application/json'
                        }
                    })
                    .then((res)=>{
                        
                    })
                    .catch((error)=>{
                        console.log(error);
                    });

                }
            }

	})
	.then(editor=>{
		window[element] = editor;
	});

}


export default CKEditorInit;